// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SnippetsOutlinedSvg from "@fishx/icons-svg/es/asn/SnippetsOutlined";
import FishxIcon from '../components/FishxIcon';

var SnippetsOutlined = function SnippetsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsOutlinedSvg
  }));
};

SnippetsOutlined.displayName = 'SnippetsOutlined';
export default React.forwardRef(SnippetsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SnippetsOutlined.js
// module id = 4166
// module chunks = 0